import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromStaticDataReducer from '../reducers';
import * as staticDataCountriesReducer from '../reducers/index';
import * as staticDataReducer from '../static-data.reducer';

//#region Static Data ROOT STATE
export const getAuthState = createFeatureSelector<staticDataReducer.State, staticDataReducer.StaticDataState>(
  staticDataReducer.staticDataFeatureKey
);
//#endregion

export const getStaticDataJurisdictionRisksState = createSelector(
  getAuthState,
  state => state[fromStaticDataReducer.fromStaticDataJurisdictionRisksReducer.staticDataJurisdictionRisksFeatureKey]
);

export const getStaticDataJurisdictionRisksFailure = createSelector(
  getStaticDataJurisdictionRisksState,
  staticDataCountriesReducer.fromStaticDataJurisdictionRisksReducer.getJurisdictionRisksError
);

export const getStaticDataJurisdictionRisksResponse = createSelector(
  getStaticDataJurisdictionRisksState,
  staticDataCountriesReducer.fromStaticDataJurisdictionRisksReducer.getJurisdictionRisks
);
